import { useContactList } from "@/api/services/admin/contact";
import { CardContainer } from "@/components/commons/CardContainer";
import { CountTable } from "@/components/elements/CountTable";
import { ContactTable } from "@/features/contact/components/ContactTable";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { useIsPageParamValid, useSanitizedPageParam } from "@/hooks/useSanitizedPageParam";
import { useQueryClient } from "@tanstack/react-query";
import { Stack } from "@mui/material";
import { FC, useEffect } from "react";
import { useLocation } from "react-router-dom";

type TUnresolvedContactListPageProps = {};

export const UnresolvedContactListPage: FC<TUnresolvedContactListPageProps> = () => {
  useSanitizedPageParam();

  const queryClient = useQueryClient();
  const location = useLocation();
  const isValidPage = useIsPageParamValid();
  const { data: contactListResult, isLoading, isFetching, refetch } = useContactList([false]);

  useEffect(() => {
    if (!isValidPage) return;

    queryClient.setQueryData([QUERY_KEYS.CONTACT.UNREAD_COUNT], 0);
    queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.CONTACT.UNREAD_COUNT] });
    queryClient.removeQueries({ queryKey: [QUERY_KEYS.CONTACT.FETCH_LIST] });
    refetch();
  }, [queryClient, location.pathname, location.key, refetch, isValidPage]);

  const showLoading = isLoading || (isFetching && !contactListResult);

  return (
    <CardContainer sx={{ borderRadius: "0 0 8px 8px" }}>
      <Stack gap={3}>
        <CountTable
          total={contactListResult?.pagination.total}
          page={contactListResult?.pagination.page}
          perPage={contactListResult?.pagination.perPage}
        />
        {contactListResult ? (
          <ContactTable isResolved={false} isLoading={showLoading} isFetching={isFetching} data={contactListResult} />
        ) : (
          <ContactTable
            isResolved={false}
            isLoading={showLoading}
            isFetching={isFetching}
            data={{
              data: [],
              pagination: { page: 1, perPage: 10, total: 0, totalPage: 0, nextPage: null, prevPage: null, count: 0 },
            }}
          />
        )}
      </Stack>
    </CardContainer>
  );
};
